import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchStore } from '@/store/search';
import { useAutocomplete } from '@/hooks/use-search-data';
import { SJCommandMenu } from './sj-command-menu';
import { ROUTES } from '@/utils/constants';

const ENTITY_ROUTES: Record<string, string> = {
  knowledge: ROUTES.KNOWLEDGE,
  industry: ROUTES.INDUSTRIES,
  goal: ROUTES.GOALS,
  workflow: ROUTES.WORKFLOWS,
  product: ROUTES.PRODUCTS,
  problem: ROUTES.KNOWLEDGE,
};

export function GlobalCommandMenu() {
  const { isOpen, close, recentSearches, addRecentSearch } = useSearchStore();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const { data: autocompleteResults = [] } = useAutocomplete(query);

  const results = query.length >= 2
    ? [
        ...autocompleteResults.map((r) => ({
          id: r.id,
          title: r.title,
          description: r.summary?.slice(0, 60) || undefined,
          category: r.entity_type,
          href: `${ENTITY_ROUTES[r.entity_type] || ROUTES.KNOWLEDGE}/${r.slug}`,
        })),
        {
          id: '__search__',
          title: `Search for "${query}"`,
          description: 'View full search results',
          category: 'search',
          href: `${ROUTES.SEARCH}?q=${encodeURIComponent(query)}`,
        },
      ]
    : [];

  const handleSearch = useCallback((q: string) => {
    setQuery(q);
  }, []);

  const handleSelect = useCallback(
    (result: { id?: string; title?: string; href?: string }) => {
      if (result.href) {
        if (query.length >= 2) addRecentSearch(query);
        navigate(result.href);
      }
      close();
      setQuery('');
    },
    [navigate, close, query, addRecentSearch]
  );

  return (
    <SJCommandMenu
      open={isOpen}
      onClose={() => { close(); setQuery(''); }}
      onSearch={handleSearch}
      onSelect={handleSelect}
      results={results}
      recentSearches={recentSearches}
      isLoading={false}
    />
  );
}
